import PropTypes from 'prop-types';
import { SearchSuggestionSection } from './search-suggestion-section';
import {
    CampaignSuggestionsListItem,
    PreviousSearchesListItem,
    SearchesSuggestionsListItem,
    ShopsSuggestionsListItem,
    AdvancedSearchListItem,
    SellerSearchListItem,
    CharitiesSuggestionsListItem
} from './suggestion-list-items';
import { KEYCODE } from '../search';
import { classNames } from 'tradera/utils/class-names';
import styles from './search-suggestions.module.scss';
import { KeywordSearchSwitch } from 'tradera/components/keyword-search-switch/keyword-search-switch';

export const SearchSuggestions = ({
    suggestions,
    inSPA,
    visible,
    onChangeSearchTerm,
    onPreviousSearchRemoved,
    searchTerm,
    selectedCategoryId,
    selectedIndex,
    searchSuggestionsElementRef,
    setIsSearchInputFocused,
    keywordSearchSwitch
}) => {
    const handleSuggestionsBlur = (e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsSearchInputFocused(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.which === KEYCODE.ESC) {
            setIsSearchInputFocused(false);
        }
    };

    return (
        <section
            className={classNames(styles.searchSuggestions, {
                [styles.searchSuggestionsVisable]: visible
            })}
            ref={searchSuggestionsElementRef}
            onBlur={handleSuggestionsBlur}
            onKeyDown={handleKeyDown}>
            {searchTerm ? (
                <>
                    {keywordSearchSwitch && (
                        <KeywordSearchSwitch
                            size="small"
                            className="px-2 py-1"
                        />
                    )}
                    <div className="list-group">
                        {suggestions.map((entry, index) => {
                            const componentProps = {
                                changeSearchTerm: onChangeSearchTerm,
                                inSPA: inSPA,
                                isSelected: index === selectedIndex,
                                item: entry.item,
                                searchTerm: searchTerm,
                                selectedCategoryId: selectedCategoryId,
                                text: entry.text,
                                queryParams: entry.queryParams
                            };
                            switch (entry.type) {
                                case 'previous':
                                    return (
                                        <PreviousSearchesListItem
                                            key={entry.key}
                                            onPreviousSearchRemoved={
                                                onPreviousSearchRemoved
                                            }
                                            {...componentProps}
                                        />
                                    );
                                case 'suggested-campaign':
                                    return (
                                        <CampaignSuggestionsListItem
                                            key={entry.key}
                                            {...componentProps}
                                        />
                                    );
                                case 'suggested-item':
                                    return (
                                        <SearchesSuggestionsListItem
                                            key={entry.key}
                                            {...componentProps}
                                        />
                                    );
                                case 'suggested-shop':
                                    return (
                                        <ShopsSuggestionsListItem
                                            key={entry.key}
                                            {...componentProps}
                                        />
                                    );
                                case 'suggested-charity':
                                    return (
                                        <CharitiesSuggestionsListItem
                                            key={entry.key}
                                            {...componentProps}
                                        />
                                    );
                                case 'link-advanced-search':
                                    return (
                                        <AdvancedSearchListItem
                                            key={entry.key}
                                            {...componentProps}
                                        />
                                    );
                                case 'link-seller-search':
                                    return (
                                        <SellerSearchListItem
                                            key={entry.key}
                                            {...componentProps}
                                        />
                                    );
                                default:
                                    throw new Error(
                                        'unhandled entry type: ',
                                        JSON.stringify(entry)
                                    );
                            }
                        })}
                    </div>
                </>
            ) : (
                <SearchSuggestionSection
                    suggestions={suggestions}
                    onPreviousSearchRemoved={onPreviousSearchRemoved}
                    searchTerm={searchTerm}
                    changeSearchTerm={onChangeSearchTerm}
                />
            )}
        </section>
    );
};

SearchSuggestions.propTypes = {
    allSuggestions: PropTypes.array,
    isSearchInputFocused: PropTypes.bool,
    onChangeSearchTerm: PropTypes.func,
    onPreviousSearchRemoved: PropTypes.func,
    previousSearches: PropTypes.array,
    searchTerm: PropTypes.string,
    selectedCategoryId: PropTypes.number,
    selectedIndex: PropTypes.number,
    setSearchSuggestionsElement: PropTypes.func,
    keywordSearchSwitch: PropTypes.bool
};
